import React from "react";
import { NewHeroWrap } from "./NewHero.styled";

const NewHero = () => {
  return (
    <section>
      <NewHeroWrap>
        <div>
          <h2>Recent News</h2>
        </div>
      </NewHeroWrap>
    </section>
  );
};

export default NewHero;
